import React from "react";

const OrderSummary = ({ cart }) => {
  const cartItems = Object.values(cart);

  return (
    <div className="border rounded-md border-default p-4">
      <h4 className="mb-4">Order Summary</h4>
      {cartItems.length === 0 ? (
        <p>No tickets added to the cart yet.</p>
      ) : (
        cartItems?.map(({ quantity, ticket }) => (
          <div key={ticket._id} className="flex justify-between mb-2">
            <div>
              <p className="mb-1 font-semibold">{`${quantity} x ${ticket.type}`}</p>
            </div>
            <div>
              <h4>{(ticket.price * quantity)?.toLocaleString()}</h4>
            </div>
          </div>
        ))
      )}
      {cartItems.length > 0 && (
        <div className="border-t-2 mt-4 pt-4 text-right">
          <h4>
            Grand Total:{" "}
            {cartItems
              .reduce(
                (total, { quantity, ticket }) =>
                  total + ticket.price * quantity,
                0
              )
              ?.toLocaleString()}
          </h4>
        </div>
      )}
    </div>
  );
};

export default OrderSummary;
